export var RESERVED_VALUE_FOR_NEGATIVE = 0.0000123456789;
export var RESERVED_VALUE_FOR_NO_DATA = 0.000019573;

export function commaSeparateNumber(str) {
  return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const FormatHelper = {
  formatEscapNumber: function(minValue, maxValue, value) {
    var result,
        absMaxValue = Math.abs(maxValue);

    if (typeof value !== 'number' || value == RESERVED_VALUE_FOR_NO_DATA) {
      return 'No data';
    } else if(value == RESERVED_VALUE_FOR_NEGATIVE){
      return '< 1';
    }
    else {
      if (absMaxValue > 100) {
        result = value.toFixed(0);
      }
      else if (absMaxValue > 10) {
        result = value.toFixed(1);
      }
      else if (absMaxValue > 1) {
        result = value.toFixed(2);
      }
      else if (absMaxValue > 0) {
        result = value.toFixed(3);
      }
      else {
        result = value.toFixed(0);
      }

      return commaSeparateNumber(result);
    }
  },
  getCommaSeparateNumber(value) {
    return commaSeparateNumber(value.toString());
  }
};
